import HistoryManageTags from '@di-shared/features/history/tags/HistoryManageTags';

interface HistoryManageTagsPageProps {
  vin: string;
}

export default function HistoryManageTagsPage({vin}: HistoryManageTagsPageProps) {
  return <HistoryManageTags vin={vin} />;
}
